const CART_PROMOTION_ADJUSTMENT_TYPES = ['order_promotion', 'order_shipping_promotion'];

export function hasCartPromotion(adjustments) {
    // order.adjustments can serialize as {} instead of [] when empty (same API Platform/Doctrine
    // collection quirk already worked around for translations in utils/dataAccess.js)
    return (Array.isArray(adjustments) ? adjustments : []).some(adjustment => CART_PROMOTION_ADJUSTMENT_TYPES.includes(adjustment.type) && adjustment.amount < 0);
}
